import styled from 'styled-components';
import DatePicker from 'react-datepicker';

export const ConsumerUnitFilterContainer = styled.div`
  width: 100%;
  max-width: 1416px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 16px;

  @media only screen and (max-width: 768px) {
    padding: 0 12px;
  }
`;

export const Wrapper = styled.div`
  max-width: 1034px;
  width: 100%;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  @media only screen and (max-width: 768px) {
    max-width: 100%;

    > div {
      flex: 1 1 calc(50% - 8px);
      min-width: 140px;
    }
  }
`;

export const LabelContainer = styled.div`
  .calendar-body-selector {
    background-color: ${(props) => props.theme.color.bg.primary};
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    color: ${(props) => props.theme.color.text.primary};
  }
`;

export const Label = styled.label`
  display: block;
  color: ${(props) => props.theme.color.ui.shade3};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-family: ${(props) => props.theme.font.body.family};
  line-height: normal;
`;

export const Select = styled.select`
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.color.ui.tertiary};
  background: ${(props) => props.theme.color.bg.primary};
  box-shadow: 0px 0px 0px 0px #cbdafc;
  height: 38px;
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-family: ${(props) => props.theme.font.body.family};
  width: 100%;
  &::placeholder {
    color: ${(props) => props.theme.color.ui.shade3};
  }
  &:focus {
    outline: none;
  }
`;

export const DateSelector = styled(DatePicker)`
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.color.ui.shade3};
  background: ${(props) => props.theme.color.bg.primary};
  box-shadow: 0px 0px 0px 0px red;
  padding: 0px 12px;
  height: 38px;
  color: ${(props) => props.theme.color.ui.shade3};
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.regular};
  font-style: normal;
  &::placeholder {
    color: ${(props) => props.theme.color.ui.shade3};
  }
  &:focus {
    outline: none;
  }
`;
